
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahireinhadapsarpune() {



    const cardData =
    {
        keyword: 'Urbania hire in Hadapsar Pune ',
        heading: 'Amruta Travels: Urbania hire in Hadapsar Pune ',
        headingDescription: 'Amruta Travels offers Urbania Hire in Hadapsar Pune, providing a comfortable and reliable solution for group travel, including corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities for a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your Urbania hire in Hadapsar Pune is safe, convenient, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania hire in Hadapsar Pune",
    "description": "Urbania hire in Hadapsar Pune offering premium and reliable group transportation for corporate travel, family outings, airport transfers, weddings, and outstation trips. Vehicles feature fully air-conditioned interiors, plush pushback seating, spacious legroom, ample luggage capacity, clean cabins, and professional drivers ensuring safe, smooth, and punctual journeys."
  },
  {
    "name": "Urbania on rent in Hadapsar",
    "description": "Urbania on rent in Hadapsar Pune for comfortable city and outstation travel. Ideal for business meetings, tours, and family trips with luxury AC interiors, modern seating layout, smooth suspension, and experienced chauffeurs familiar with Hadapsar and nearby routes."
  },
  {
    "name": "Force Urbania hire Hadapsar Pune",
    "description": "Force Urbania hire in Hadapsar Pune delivering luxury mini bus services for small and medium groups. Well-maintained AC vehicles with spacious seating, excellent ride quality, luggage space, and courteous drivers for local and long-distance travel."
  },
  {
    "name": "Urbania rental service Hadapsar",
    "description": "Urbania rental service in Hadapsar providing dependable, flexible, and affordable transport solutions. Suitable for corporate offices, IT companies, families, and tourists with AC comfort, clean interiors, and punctual service."
  },
  {
    "name": "Urbania Bus hire in Hadapsar",
    "description": "Urbania bus hire in Hadapsar for group travel needs such as corporate events, weddings, picnics, and tours. Enjoy spacious AC interiors, comfortable seating, safety features, and trained drivers."
  },
  {
    "name": "13 seater Urbania hire Hadapsar",
    "description": "13 seater Urbania hire in Hadapsar ideal for family trips, airport transfers, and small corporate groups. Features AC interiors, pushback seats, sufficient luggage space, and professional chauffeurs."
  },
  {
    "name": "17 seater Urbania on rent Hadapsar",
    "description": "17 seater Urbania on rent in Hadapsar for larger groups and corporate teams. Luxury AC interiors, wide seating layout, ample legroom, luggage capacity, and smooth ride quality ensure premium travel."
  },
  {
    "name": "Luxury Urbania hire Hadapsar",
    "description": "Luxury Urbania hire in Hadapsar for premium travel experiences. Best suited for executives, VIP guests, and weddings with elegant AC interiors, plush seating, and disciplined drivers."
  },
  {
    "name": "AC Urbania van hire Hadapsar",
    "description": "AC Urbania van hire in Hadapsar offering cool, comfortable, and relaxed journeys. Ideal for all seasons with powerful air-conditioning, clean cabins, and comfortable seating."
  },
  {
    "name": "Force Urbania 17 seater Hadapsar",
    "description": "Force Urbania 17 seater in Hadapsar for corporate travel, family outings, and outstation tours. Offers AC comfort, spacious interiors, luggage space, and experienced highway drivers."
  },
  {
    "name": "Urbania hire near Magarpatta City",
    "description": "Urbania hire near Magarpatta City for corporate offices, IT professionals, and residential societies. Luxury AC vehicles with punctual service and professional chauffeurs."
  },
  {
    "name": "Urbania on rent near Amanora Hadapsar",
    "description": "Urbania on rent near Amanora Hadapsar for city travel, airport transfers, and outstation trips. Spacious AC interiors and reliable drivers ensure stress-free journeys."
  },
  {
    "name": "Urbania rental near SP Infocity Hadapsar",
    "description": "Urbania rental near SP Infocity Hadapsar catering to IT companies and corporate guests. Premium AC comfort, clean interiors, and disciplined drivers meet business travel standards."
  },
  {
    "name": "Urbania van hire near Fatima Nagar",
    "description": "Urbania van hire near Fatima Nagar for family, corporate, and event travel. Comfortable AC interiors, ample seating, and professional service."
  },
  {
    "name": "Urbania on rent near Sasane Nagar",
    "description": "Urbania on rent near Sasane Nagar Hadapsar for group travel with AC luxury, smooth ride quality, and experienced drivers."
  },
  {
    "name": "Urbania hire Hadapsar for corporate travels",
    "description": "Urbania hire in Hadapsar for corporate meetings, conferences, seminars, and employee transportation. Premium AC interiors, punctual drivers, and reliable service."
  },
  {
    "name": "Urbania on rent Hadapsar for airport transfer",
    "description": "Urbania on rent in Hadapsar for airport transfers with timely pickup and drop. Spacious AC interiors, luggage-friendly design, and drivers experienced with airport routes."
  },
  {
    "name": "Urbania hire Hadapsar for family trip",
    "description": "Urbania hire in Hadapsar for family trips offering safety, comfort, and space. Ideal for vacations, outings, and temple visits with AC comfort."
  },
  {
    "name": "Urbania rental Hadapsar for outstation",
    "description": "Urbania rental in Hadapsar for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more. Comfortable AC interiors and reliable vehicles for long journeys."
  },
  {
    "name": "Urbania van hire Hadapsar for wedding",
    "description": "Urbania van hire in Hadapsar for wedding transportation. Perfect for guest and family movement with luxury AC interiors and professional chauffeurs."
  },
  {
    "name": "Urbania on rent near Hadapsar Pune",
    "description": "Urbania on rent near Hadapsar Pune with quick availability and doorstep pickup. Suitable for corporate, family, and airport travel needs."
  },
  {
    "name": "Urbania airport pickup Hadapsar",
    "description": "Urbania airport pickup service from Hadapsar ensuring punctual arrivals, AC comfort, and sufficient luggage space for families and corporate guests."
  },
  {
    "name": "Urbania Pune Airport drop from Hadapsar",
    "description": "Urbania Pune Airport drop service from Hadapsar with timely departures, luxury AC interiors, and smooth travel experience."
  },
  {
    "name": "Urbania corporate hire Hadapsar Pune",
    "description": "Urbania corporate hire in Hadapsar Pune for office travel, client meetings, and staff transportation. Premium AC vehicles and disciplined drivers."
  },
  {
    "name": "Urbania Bus hire Hadapsar for IT companies",
    "description": "Urbania bus hire in Hadapsar for IT companies offering reliable and comfortable employee and guest transportation with AC comfort."
  },
  {
    "name": "Urbania hire Hadapsar price",
    "description": "Urbania hire price in Hadapsar offering transparent and competitive rates. Cost-effective packages with luxury AC vehicles and professional service."
  },
  {
    "name": "Urbania hire Hadapsar per km rate",
    "description": "Urbania hire in Hadapsar available on per km basis for flexible local and outstation travel with affordable pricing."
  },
  {
    "name": "Affordable Urbania rental Hadapsar",
    "description": "Affordable Urbania rental in Hadapsar providing premium travel at budget-friendly prices without compromising comfort or safety."
  },
  {
    "name": "Cheap Urbania hire in Hadapsar",
    "description": "Cheap Urbania hire in Hadapsar for economical group travel with AC comfort, clean vehicles, and reliable drivers."
  },
  {
    "name": "Best Urbania rental service Hadapsar",
    "description": "Best Urbania rental service in Hadapsar known for luxury vehicles, experienced drivers, punctual service, and high customer satisfaction."
  }
],
"tableData": [
  ["Urbania hire in Hadapsar Pune", "Urbania on rent in Hadapsar"],
  ["Force Urbania hire Hadapsar Pune", "Urbania rental service Hadapsar"],
  ["Urbania Bus hire in Hadapsar", "13 seater Urbania hire Hadapsar"],
  ["17 seater Urbania on rent Hadapsar", "Luxury Urbania hire Hadapsar"],
  ["AC Urbania van hire Hadapsar", "Force Urbania 17 seater Hadapsar"],
  ["Urbania hire near Magarpatta City", "Urbania on rent near Amanora Hadapsar"],
  ["Urbania rental near SP Infocity Hadapsar", "Urbania van hire near Fatima Nagar"],
  ["Urbania hire Hadapsar for corporate travels", "Urbania on rent Hadapsar for airport transfer"],
  ["Urbania hire Hadapsar for family trip", "Urbania rental Hadapsar for outstation"],
  ["Urbania van hire Hadapsar for wedding", "Urbania airport pickup Hadapsar"],
  ["Urbania Pune Airport drop from Hadapsar", "Urbania corporate hire Hadapsar Pune"],
  ["Urbania Bus hire Hadapsar for IT companies", "Affordable Urbania rental Hadapsar"],
  ["Cheap Urbania hire in Hadapsar", "Best Urbania rental service Hadapsar"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania Hire in Hadapsar Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire in Hadapsar Pune, providing comfortable, stylish, and dependable travel solutions for corporate trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, family outing, wedding transport, or city sightseeing, our Urbania rentals in Hadapsar ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, wide windows, and ample luggage space, making them ideal for short city rides and long-distance trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania hires include trained and courteous drivers who ensure punctuality, safety, and a pleasant travel experience throughout Hadapsar and Pune."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Urbania hire in Hadapsar, giving you excellent value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations with customized routes to suit your travel plan within Hadapsar, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania hire in Hadapsar Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania hire in Hadapsar Pune?',
    answer: 'You can book an Urbania hire in Hadapsar Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Hadapsar?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Hadapsar.'
  },
  {
    question: 'Can I hire Urbania in Hadapsar for outstation trips?',
    answer: 'Yes, we provide Urbania hires from Hadapsar for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania hire include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Urbania hire in Hadapsar Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Hadapsar?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire in Hadapsar Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ashok Pawar',
    role: 'Corporate Manager, Hadapsar',
    text: 'We hired an Urbania from Hadapsar for a corporate event. The vehicle was clean, comfortable, and the driver was punctual and professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Meera Kulkarni',
    role: 'Family Traveler, Hadapsar',
    text: 'Booked an Urbania hire in Hadapsar for a family trip. The ride was smooth, spacious, and very comfortable. Highly recommend Amruta Travels!',
    rating: 5
  }
];























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire in Hadapsar Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-hire-hadapsar.jpg",
  "description": "Urbania hire in Hadapsar Pune with Amruta Travels. Rent 13 & 17 seater Force Urbania vans for corporate travel, airport transfers, family trips, weddings, outstation journeys, and local sightseeing. Service areas include Magarpatta City, Amanora, SP Infocity, Fatima Nagar, Sasane Nagar, and surrounding Hadapsar locations with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2880"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6250",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-hire-hadapsar"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Hire in Hadapsar Pune | Force Urbania Rental | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania hire in Hadapsar Pune with Amruta Travels. Rent 13 & 17 seater Force Urbania vans for corporate travel, airport transfers, family trips, weddings, and outstation journeys at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/113.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireinhadapsarpune;